import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { T as Tooltip } from '../Tooltip/Tooltip-Ws22o3JR.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BGx4v_Uj-CJNeXUZQ.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { l as longArrowAltUp } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { B as Button } from '../Button/Button-BhD27vh-.js';
import { I as Icon } from '../Icon/Icon-CtwBWqCc.js';

const IconButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30063520__sc-9z0xe0-0"
})(["background:", ";border-radius:50%;display:flex;align-items:center;justify-content:center;height:20px;width:20px;padding:unset;:hover{background:", ";}"], ({
  theme,
  $active
}) => $active ? theme.palette.blue[700] : theme.palette.gray[500], ({
  theme
}) => theme.palette.gray[500]);
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30063520__sc-9z0xe0-1"
})(["color:", ";/*! @noflip */ [dir=\"rtl\"] && > svg{/*! @noflip */ transform:scaleX(-1);}"], ({
  theme,
  disabled
}) => disabled ? theme.palette.gray[500] : 'white');
const SendButton = ({
  onClick,
  disabled,
  isActive = false
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'send-button'
  });
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    nonInteractive: true,
    inert: disabled,
    trigger: /*#__PURE__*/React__default.createElement("span", {
      "aria-label": formatMessage({
        id: 'action-send'
      })
    }, /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getDataTaktAttributes(), {
      transparent: true,
      onClick: onClick,
      disabled: disabled,
      $active: isActive
    }), /*#__PURE__*/React__default.createElement(StyledIcon, {
      disabled: disabled,
      type: longArrowAltUp,
      transform: "rotate-90",
      size: "sm"
    }))),
    message: formatMessage({
      id: 'action-send'
    })
  });
};

export { SendButton as S };
//# sourceMappingURL=SendButton-CIHvKV9F.js.map
